import { property } from 'lit/decorators.js';
import { CrntElement } from '../../lib/crnt-element.js';

var __defProp = Object.defineProperty;
var __decorateClass = (decorators, target, key, kind) => {
  var result = void 0 ;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (decorator(target, key, result) ) || result;
  if (result) __defProp(target, key, result);
  return result;
};
class CrntIcon extends CrntElement {
  constructor() {
    super(...arguments);
    this.ariaLabel = null;
    this.size = "base";
    this.square = false;
  }
  static {
    this.tagName = "crnt-icon";
  }
  willUpdate(changedProperties) {
    if (changedProperties.has("ariaLabel")) {
      this.ariaHidden = this.ariaLabel ? null : "true";
    }
  }
}
__decorateClass([
  property({ reflect: true })
], CrntIcon.prototype, "animation");
__decorateClass([
  property({ attribute: "aria-label", reflect: true })
], CrntIcon.prototype, "ariaLabel");
__decorateClass([
  property({ reflect: true })
], CrntIcon.prototype, "icon");
__decorateClass([
  property({ reflect: true })
], CrntIcon.prototype, "size");
__decorateClass([
  property({ reflect: true, type: Boolean })
], CrntIcon.prototype, "square");

export { CrntIcon };
